import store from '@/store'

/**
 * 验证工序标签
 * @returns 
 */
function validProcessTabAuth(tabCode) {
  return store.getters.getCurrProcessTabs.findIndex(item => item == tabCode) != -1
}

export default {
  validProcessTabAuth
}